module.exports = __webpack_public_path__ + "static/media/sign-up-btn.fe605512.svg";